import React, { useState, useEffect } from 'react';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import CategoriesNavBar from '../../../Components/CategoriesNavBar/CategoriesNavBar';
import Box from '@mui/material/Box';
import './style.css';
import { scroller } from 'react-scroll';
import { Link, useParams, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Modal from '@mui/material/Modal';
import { useCart } from '../../../CartContext';
import { useGlobal } from '../../../GlobalContext';
import gluten from '../../../Assets/icons/gluten.png';
import acucar from '../../../Assets/icons/acucar.png';
import laticinios from '../../../Assets/icons/laticinios.png';
import vegano from '../../../Assets/icons/vegano.png';
import vegetariano from '../../../Assets/icons/vegetariano.png';
import produtoSemImagem from '../../../Assets/produto-sem-imagem.png';
import Loading from '../../../Components/Loading';
import FloatingOrderButton from '../../../Components/FloatingOrderButton';
import ProgressiveImage from '../../../Components/ProgressiveImage';
import { formatDescription, truncateHtml } from '../../../Utills/formatText';
import { resolveClientColor } from '../../../Utills/colors';
import { t } from '../../../Utills/translations';

const { REACT_APP_URL_API } = process.env;

const style = {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--background)',
  border: '2px solid var(--title)',
  boxShadow: 24,
  p: 4,
};

const generateUUID = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

const sanitizeId = (str) =>
  String(str)
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9\-_]/g, '')
    .toLowerCase();

const FacilitiesCardapio = () => {
  const { menu, loading, refreshCart } = useGlobal();
  const { addItemToCart } = useCart();
  const { cliente_id, tipo_id, item_id } = useParams();
  const location = useLocation();
  const cookies = new Cookies();

  const token = cookies.get('csrftoken2');
  const itemId = parseInt(item_id, 10);
  const userIp = localStorage.getItem('ip_address');
  const [session] = useState(localStorage.getItem('session') || generateUUID());
  const [abrir, setAbrir] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [modalText, setModalText] = useState('');
  const [isAdded, setIsAdded] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [selectedAdicionais, setSelectedAdicionais] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [quantidade, setQuantidade] = useState(1);

  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  // ✅ Scroll inicial até a primeira categoria
  useEffect(() => {
    if (!loading && menu) {
      const tipoRefeicaoTemp = menu.tipo_refeicao.find(
        (tipo) => tipo.id === parseInt(tipo_id),
      );

      const categoriasAtivas = tipoRefeicaoTemp?.categoria_cardapio?.filter(
        (c) => c.status === true,
      );

      if (categoriasAtivas && categoriasAtivas.length > 0) {
        const firstCategoryId = sanitizeId(String(categoriasAtivas[0].id));
        setTimeout(() => {
          scroller.scrollTo(firstCategoryId, {
            duration: 600,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -70,
          });
        }, 100);
      }
    }
  }, [loading, menu, tipo_id]);

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categoriasNav, setCategoriasNav] = useState([]);
  const [isFiltering, setIsFiltering] = useState(true);

  useEffect(() => {
    if (!menu) return;

    setIsFiltering(true);

    const tipoRefeicao = menu.tipo_refeicao.find(
      (tipo) => tipo.id === parseInt(tipo_id),
    );

    if (!tipoRefeicao) {
      setIsFiltering(false);
      return;
    }

    const todasCategorias = tipoRefeicao.categoria_cardapio || [];
    const categoriasAtivas = todasCategorias.filter((c) => !!c.status);
    const idsItensCategoriasAtivas = new Set(
      categoriasAtivas.flatMap((c) => (c.item_cardapio || []).map((i) => i.id)),
    );
    const idsItensCategoriasInativas = new Set(
      todasCategorias
        .filter((c) => !c.status)
        .flatMap((c) => (c.item_cardapio || []).map((i) => i.id)),
    );

    const seenItemIds = new Set();
    const newFiltered = [];
    const navCategories = [];

    for (const categoria of categoriasAtivas) {
      const filteredItems = (categoria.item_cardapio || []).filter((item) => {
        const termo = searchTerm.toLowerCase();
        const nome = (item.nome || '').toLowerCase();
        const descricao = (item.descricao || '').toLowerCase();
        return (
          item.status &&
          (nome.includes(termo) || descricao.includes(termo)) &&
          !seenItemIds.has(item.id)
        );
      });

      if (filteredItems.length > 0) {
        newFiltered.push({
          id: categoria.id,
          nome: categoria.nome,
          filteredItems,
        });
        navCategories.push({
          id: categoria.id,
          nome: categoria.nome,
        });
        filteredItems.forEach((i) => seenItemIds.add(i.id));
      }
    }

    const itemsSemCategoria = (tipoRefeicao.item_cardapio_sem_cat || []).filter(
      (item) => {
        const termo = searchTerm.toLowerCase();
        const nome = (item.nome || '').toLowerCase();
        const descricao = (item.descricao || '').toLowerCase();
        const match = nome.includes(termo) || descricao.includes(termo);
        const ativo = !!item.status;
        const naoPertenceCategoria =
          !idsItensCategoriasAtivas.has(item.id) &&
          !idsItensCategoriasInativas.has(item.id) &&
          !seenItemIds.has(item.id);
        return ativo && match && naoPertenceCategoria;
      },
    );

    if (itemsSemCategoria.length > 0) {
      newFiltered.push({
        id: `semcat-${tipoRefeicao.id}`,
        nome: 'Outros Itens',
        filteredItems: itemsSemCategoria,
      });
      navCategories.push({
        id: `semcat-${tipoRefeicao.id}`,
        nome: 'Outros Itens',
      });
    }

    setFilteredCategories(newFiltered);
    setCategoriasNav(navCategories);
    setIsFiltering(false);
  }, [menu, tipo_id, searchTerm]);

  if (loading || !menu || isFiltering) {
    return (
      <div className="loading-container">
        <Loading />
      </div>
    );
  }

  const cor2 = resolveClientColor();
  const cor_letra = localStorage.getItem('cliente_cor_letra');
  const cor_custom = localStorage.getItem('cliente_cor_custom');
  const tipoRefeicao = menu.tipo_refeicao.find(
    (tipo) => tipo.id === parseInt(tipo_id),
  );

  if (!tipoRefeicao) return null;
  // Assume habilitado por padrão; só desativa se o backend gravar explicitamente 'false'
  const habilitaPedido =
    localStorage.getItem('cliente_pedido_menu') !== 'false';

  // Define a cor da barra de navegação (prioriza cor personalizada, senão usa preto)
  const navBarColor =
    cor_custom && cor_custom !== 'outra' ? cor_custom : '#000000';

  const handleAbrir = (item) => {
    setCurrentItem(item);
    setModalText(
      item.grupo_item_adicional || item.grupo_item_adicional_2
        ? t('selecioneAcompanhamento')
        : t('confirmarInclusao'),
    );
    setAbrir(true);
  };

  const handleFechar = () => {
    setAbrir(false);
    setCurrentItem(null);
    setSelectedAdicionais({});
  };

  const countSelecionadosNoGrupo = (grupoIndex) =>
    Object.keys(selectedAdicionais).filter((k) =>
      k.startsWith(`adicional-${grupoIndex}-`),
    ).length;

  const handleCheckboxChange = (grupoIndex, adicionalIndex, limit = 999) => {
    const key = `adicional-${grupoIndex}-${adicionalIndex}`;
    setSelectedAdicionais((prev) => {
      if (prev[key]) {
        const newState = { ...prev };
        delete newState[key];
        return newState;
      }
      if (countSelecionadosNoGrupo(grupoIndex) >= limit) return prev;
      return { ...prev, [key]: true };
    });
  };

  const handleAddToCart = () => {
    if (!currentItem?.id || isAdding || isAdded) return;

    setIsAdding(true);

    const grupos = [
      currentItem.grupo_item_adicional,
      currentItem.grupo_item_adicional_2,
    ];

    const additional_items = Object.keys(selectedAdicionais)
      .filter((key) => selectedAdicionais[key])
      .map((key) => {
        const parts = key.split('-');
        const grupoIndex = parseInt(parts[1], 10);
        const itemIndex = parseInt(parts[2], 10);
        return grupos[grupoIndex]?.items?.[itemIndex]?.[1];
      })
      .filter(Boolean);

    const payload = {
      cliente_id,
      ip_address: userIp,
      session,
      language: navigator.language || navigator.userLanguage || 'pt-BR',
      operation: 'add',
      items: [
        {
          id: currentItem.id,
          quantity: quantidade,
          additional_items,
        },
      ],
    };

    fetch(
      `${REACT_APP_URL_API}/apiv2/cart/update/?x=${apartamento}&id_cliente=${cliente_url}&session_control=${session_control}&language=${navigator.language || navigator.userLanguage || 'pt-BR'}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': token },
        body: JSON.stringify(payload),
      },
    )
      .then((r) => r.json())
      .then((data) => {
        console.log('Item adicionado ao carrinho:', data);

        const storedCount = localStorage.getItem('cartItemsCount');
        const updatedCount = storedCount
          ? parseInt(storedCount, 10) + quantidade
          : quantidade;
        localStorage.setItem('cartItemsCount', updatedCount.toString());

        if (typeof refreshCart === 'function') {
          refreshCart();
        }

        setIsAdded(true);
        window.dispatchEvent(new Event('cartUpdated'));

        setTimeout(() => {
          setIsAdded(false);
          setIsAdding(false);
          handleFechar();
        }, 1200);
      })
      .catch((err) => {
        console.error('Erro ao adicionar item:', err);
        setIsAdding(false);
      });
  };

  const renderGrupoItems = (grupo, grupoIndex) => {
    const limit = grupo.group_select_limit || 999;
    const currentCount = countSelecionadosNoGrupo(grupoIndex);

    return (
      <>
        {limit < 999 && (
          <p className="limite-selecao">
            {currentCount}/{limit}{' '}
            {currentCount >= limit ? '— limite atingido' : 'itens selecionados'}
          </p>
        )}
        {(grupo.items || []).map((item, index) => {
          const isChecked =
            !!selectedAdicionais[`adicional-${grupoIndex}-${index}`];
          const isDisabled = !isChecked && currentCount >= limit;
          return (
            <div
              key={`${grupoIndex}-${item[1] ?? index}`}
              className="div-opcionais"
            >
              <input
                type="checkbox"
                id={`adicional-${grupoIndex}-${index}`}
                onChange={() => handleCheckboxChange(grupoIndex, index, limit)}
                checked={isChecked}
                disabled={isDisabled}
              />
              <label
                htmlFor={`adicional-${grupoIndex}-${index}`}
                style={{ opacity: isDisabled ? 0.4 : 1 }}
              >
                {item[1]}
              </label>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div style={{ paddingTop: '60px' }}>
      <HeaderCardapio searchTerm={searchTerm} setSearchTerm={setSearchTerm} />

      {categoriasNav.length > 0 && (
        <CategoriesNavBar
          categories={categoriasNav}
          themeColor={cor2}
          offset={-130}
          showAllButton={true}
        />
      )}

      <Box
        sx={{
          maxWidth: '930px',
          margin: '10px auto 160px auto',
          left: '1%',
          right: '1%',
          bgcolor: 'var(--background-main)',
        }}
      >
        {filteredCategories.length === 0 ? (
          <div className="no__results">
            <ErrorOutlineIcon />
            <p>Nenhum item encontrado.</p>
          </div>
        ) : (
          filteredCategories.map((categoria) => {
            const catKey = String(categoria.id);
            const sectionId = sanitizeId(catKey);
            return (
              <div
                className={categoria.nome}
                name={categoria.nome}
                id={sectionId}
                key={catKey}
              >
                <div className="container-clube-voucher">
                  <h2
                    style={{
                      color: 'var(--secondary)',
                      fontSize: '16px',
                      fontWeight: 300,
                      padding: '0px 0px 10px 10px',
                    }}
                  >
                    {categoria.nome}
                  </h2>

                  {categoria.filteredItems.map((item) => (
                    <div key={item.id}>
                      <Link
                        to={`/${cliente_id}/cardapioitem/${item.id}/${location.search}`}
                        className={`cardapio-container-grid ${
                          !item.img ? 'sem-imagem' : ''
                        }`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        {/* Imagem à esquerda */}
                        <div className="cardapio-imagem">
                          <ProgressiveImage
                            src={
                              item.img
                                ? `${REACT_APP_URL_API}${item.img}`
                                : produtoSemImagem
                            }
                            alt={item.nome}
                            className="img-item-cardapio"
                          />
                        </div>

                        {/* Conteúdo à direita */}
                        <div className="cardapio-conteudo">
                          <p className="nome-cardapio">
                            <b>{item.nome}</b>
                          </p>
                          <p
                            className="descricao-cardapio"
                            dangerouslySetInnerHTML={{
                              __html:
                                item.descricao?.length > 80
                                  ? truncateHtml(
                                      formatDescription(item.descricao),
                                      80,
                                    )
                                  : formatDescription(item.descricao),
                            }}
                          />
                          <div className="img-restricao">
                            {item.gluten_free && (
                              <img src={gluten} alt="gluten" />
                            )}
                            {item.sugar_free && (
                              <img src={acucar} alt="acucar" />
                            )}
                            {item.dairy_free && (
                              <img src={laticinios} alt="laticinios" />
                            )}
                            {item.vegan && <img src={vegano} alt="vegano" />}
                            {item.vegetarian && (
                              <img src={vegetariano} alt="vegetariano" />
                            )}
                          </div>

                          <div className="cardapio-rodape">
                            <p className="price-cardapio">
                              R${' '}
                              {parseFloat(item.valor).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </p>

                            {habilitaPedido && !!item.habilita_pedido && (
                              <button
                                className="btn_cardapio"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleAbrir(item);
                                }}
                                style={{
                                  background: cor2,
                                  color: cor_letra,
                                }}
                              >
                                {t('adicionar')}
                              </button>
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
                
              </div>
              
            );
          })
        )}
      </Box>

      <Modal
        open={abrir}
        onClose={handleFechar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="container-modal">
            {currentItem && (
              <>
                <h2 id="modal-modal-title">{modalText}</h2>
                <div className="modal_cardapio_img">
                  <ProgressiveImage
                    src={
                      currentItem.img
                        ? `${REACT_APP_URL_API}${currentItem.img}`
                        : produtoSemImagem
                    }
                    alt={currentItem.nome}
                  />
                </div>
                <div className="modal-conteudo">
                  <p>{currentItem.nome}</p>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formatDescription(currentItem.descricao),
                    }}
                  />
                </div>

                {currentItem.grupo_item_adicional && (
                  <h3 className="title-h3-cardapio">
                    {t('selecioneAdicionais')}
                  </h3>
                )}

                {currentItem.grupo_item_adicional &&
                  Array.isArray(currentItem.grupo_item_adicional.items) &&
                  currentItem.grupo_item_adicional.items.length > 0 && (
                    <div className="opcionais-container">
                      <h4 className="title-h3-cardapio">
                        {currentItem.grupo_item_adicional.group_name}
                      </h4>
                      {renderGrupoItems(currentItem.grupo_item_adicional, 0)}
                    </div>
                  )}

                {currentItem.grupo_item_adicional_2 &&
                  Array.isArray(currentItem.grupo_item_adicional_2.items) &&
                  currentItem.grupo_item_adicional_2.items.length > 0 && (
                    <div className="opcionais-container">
                      <h4 className="title-h3-cardapio">
                        {currentItem.grupo_item_adicional_2.group_name}
                      </h4>
                      {renderGrupoItems(currentItem.grupo_item_adicional_2, 1)}
                    </div>
                  )}

                {Array.isArray(currentItem.grupo_item_adicional_2) &&
                  currentItem.grupo_item_adicional_2.length > 0 && (
                    <div className="opcionais-container">
                      {currentItem.grupo_item_adicional_2.map(
                        (grupo, grupoIndex) => (
                          <div key={grupoIndex}>
                            <h4 className="title-h3-cardapio">{grupo.nome}</h4>
                            {renderGrupoItems(grupo, grupoIndex)}
                          </div>
                        ),
                      )}
                    </div>
                  )}
              </>
            )}

            <button
              className={`btn-cardapio-add ${isAdded ? 'added' : ''} ${
                isAdding ? 'adding' : ''
              }`}
              style={{
                background: isAdded ? 'var(--success)' : cor2,
                color: isAdded ? '#fff' : cor_letra,
              }}
              onClick={handleAddToCart}
              disabled={isAdding || isAdded}
            >
              {isAdded ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-check"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  {t('adicionado')}
                </>
              ) : (
                `${t('adicionar')}: R$${(
                  currentItem?.valor * quantidade
                ).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              )}
            </button>
          </div>
        </Box>
      </Modal>
      <FloatingOrderButton themeColor={cor2} textColor={cor_letra} />
       <div className='div__vazia'>
                        </div>
    </div>
  );
};

export default FacilitiesCardapio;
